export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceFunctionName: "警戒レベル告知機能",
      keikaiSetting: {
        keikaiJingleFile: {
          fileName: "jingle.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        keikaiSoundFile: {
          fileName: "keikai.mp3",
          contentType: "audio/mpeg",
          fileUri: "/mp3/img01.mp3",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        keikaiLevel0TextMain: "防災訓練メイン",
        keikaiLevel0TextSub: "防災訓練サブ",
        keikaiLevel1TextMain: "警戒レベル1メイン",
        keikaiLevel1TextSub: "警戒レベル1サブ",
        keikaiLevel2TextMain: "警戒レベル2メイン",
        keikaiLevel2TextSub: "警戒レベル2サブ",
        keikaiLevel3TextMain: "警戒レベル3メイン",
        keikaiLevel3TextSub: "警戒レベル3サブ",
        keikaiLevel41TextMain: "警戒レベル4（避難勧告）メイン",
        keikaiLevel41TextSub: "警戒レベル4（避難勧告）サブ",
        keikaiLevel42TextMain: "警戒レベル４（避難指示）メイン",
        keikaiLevel42TextSub: "警戒レベル４（避難指示）サブ",
        keikaiLevel5TextMain: "警戒レベル5メイン",
        keikaiLevel5TextSub: "警戒レベル5サブ",
        noteText: " 注意書テキスト",
        okBtnActionType: 2,
        okBtnActionParameter: {
          localFile: {
            fileName: "terms.pdf",
            contentType: "application/pdf",
            fileUri: "/pdf/img01.pdf",
            fileSize: 1024,
            thumbnailUri: "/images/img01.png"
          },
        },
        // okBtnActionParameter: {
        //   screenCode: "アプリ画面コード(前の画面へ戻る場合はnull)",
        //   webUrl: "webサイトURL",
        //   localFile: {
        //     fileName: "terms.pdf",
        //     contentType: "application/pdf",
        //     fileUri: "/pdf/img01.pdf",
        //     fileSize: 1024,
        //     thumbnailUri: "/images/img01.png"
        //   },
        //   dropBoxFile: {
        //     serviceDropboxUuid: 'dropbox001',
        //     fileType: 0,
        //     useType: 2
        //   },
        //   launchSpApp: "起動するアプリパッケージ名",
        // },
        backBtnActionType: 4,
        backBtnActionParameter: {
          screenCode: "contentsscreen022"
        }
      }
    }
  }
}